<template>
  <div class="footer" v-if="!ifOtherHeader">
    <div class="footer-box clearfix">
      <div class="footer-logo">
        <div class="header-qrcode clearfix">
          <!-- <img src="./assets/images/common/ewm-img2.png" alt class="qr-code"> -->
          <div class="qr-code">
            <qrcode :value="qrcodeUrl" :options="{ size: 115 }"></qrcode>
          </div>
          <div class="scan">
            <p class="scan-care">
              <img
                src="@/assets/images/common/mobile-icon2.png"
                class="mobile-icon"
              />
              <span class="scan-text">扫码关注</span>
            </p>
            <p class="know-more">
              <span>扫一扫了解更多</span>
            </p>
          </div>
        </div>
      </div>
      <div class="footer-info">
        <!-- <div class="shop-info" v-if="ifShopInfo">
            <div class="shop-img">
              <img class="bgc-img" :src="shopInfoData.logoUrl" alt>
            </div>
          </div>
          <h1 class="logo" v-else>
            <img :src="merchantData.logoAddr">
          </h1> -->
        <div class="footer-about">
          <h2 class="about-title">关于我们</h2>
          <ul class="about-ul clearfix">
            <li>
              <label>网站名称：</label>
              <span>{{ merchantData.name }}</span>
            </li>
            <!-- <li>
                <label>公司名称：</label>
                <span>{{merchantData.name}}</span>
              </li> -->
            <li>
              <label>服务热线：</label>
              <span>{{ merchantData.customerService }}</span>
            </li>
            <li>
              <label>地址：</label>
              <span
                >{{ merchantData.addrCode }}{{ merchantData.addrDetail }}</span
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="copyright">
      <p class="copyright-text">
        技术支持：@2019浙江深大智能科技有限公司 | 浙ICP备09019008号
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import qrcode from "@xkeshi/vue-qrcode";
export default {
  name: "Header",
  props: {
    ifOtherHeader: {
      type: Boolean
    },
    qrcodeUrl: {
      type: String
    },
    merchantData: {
      type: Object
    },
  },
  data() {
    return {};
  },
  components: {
    qrcode,
  },
  computed: {
    ...mapState(["login"])
  },
  created() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.foot-logo {
  float: left;
  width: 170px;
  height: 55px;
  padding-right: 15px;
  border-right: 1px dotted #fff;
  margin-right: 15px;
  margin-top: 15px;
}
.foot-logo img {
  width: 100%;
  height: 100%;
}

.foot-info {
  text-align: center;
}
.foot-info p {
  color: #82664b;
  height: 18px;
  line-height: 18px;
}
.footer {
  width: 100%;
  // height: 217px;
  height: 187px;
  background: #fff;
  // border-top: 1px solid #ededed;
  .footer-box {
    width: 1200px;
    margin: 0 auto;
    // background-color: #f63;
    // height: 202px;
    // height: 182px;
    height: 152px;
    .footer-logo {
      // width: 120px;
      float: left;
      .header-qrcode {
        margin-left: 120px;
        margin-top: 20px;
        width: 215px;
        margin-right: 0;
        height: 115px;
        .qr-code {
          width: 115px;
          height: 115px;
        }
        .scan {
          margin-top: 52px;
          margin-left: 15px;
          .scan-care {
            .scan-text {
              font-size: 15px;
            }
            .mobile-icon {
              width: 18px;
              height: 28px;
            }
          }
          .know-more {
            margin-top: 5px;
          }
        }
      }
    }
    .footer-info {
      float: left;
      margin-left: 65px;
      margin-top: 20px;
      .logo {
        // width: 182px;
        max-width: 182px;
        height: 58px;
        margin-top: 20px;
        // margin-left: 40px;

        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
      .footer-about {
        margin-top: 15px;
        width: 700px;
        .about-title {
          font-size: 12px;
          color: #413838;
          border-bottom: 1px dashed #ddd;
          height: 24px;
          line-height: 24px;
        }
        .about-ul {
          margin-top: 10px;
          margin-left: -5%;
          li {
            float: left;
            width: 45%;
            margin-left: 5%;
            line-height: 18px;
            color: #999;
            font-size: 12px;
            // height: 36px;
          }
        }
      }
      .shop-info {
        // width: 182px;
        height: 58px;
        margin-top: 5px;
        // background-color: #fff;
        position: relative;
        .bgc-img {
          max-width: 100%;
          height: 58px;
        }
      }
    }
  }
  .copyright {
    height: 35px;
    line-height: 35px;
    background-color: #413838;
    width: 100%;
    overflow: hidden;
    .copyright-text {
      color: #fff;
      font-size: 12px;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue